import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const CARDS = [
  {
    id: "steel",
    name: "Stainless Steel",
    items: "Kadai · Bowl · Dabara · Saucepan · Plate · Tiffin Box · Tiffin Carrier",
    img: "https://images.unsplash.com/photo-1781082580025-407abed1d50f?crop=entropy&cs=srgb&fm=jpg&q=85",
    className: "md:col-span-8 md:row-span-2",
  },
  {
    id: "knives",
    name: "Kitchen Knives",
    items: "Sharp, dependable blades for every chopping board",
    img: "https://images.unsplash.com/photo-1690983321709-0eccbcb20d00?crop=entropy&cs=srgb&fm=jpg&q=85",
    className: "md:col-span-4 md:row-span-2",
  },
  {
    id: "aluminium",
    name: "Aluminium",
    items: "Tawa · Cooker · Kadai · Appachatti · Utensils",
    img: "https://images.unsplash.com/photo-1753183210437-24ec9444dad7?crop=entropy&cs=srgb&fm=jpg&q=85",
    className: "md:col-span-4",
  },
  {
    id: "nonstick",
    name: "Non-stick",
    items: "Tawa · Kadai",
    img: "https://images.unsplash.com/photo-1621494547944-5ddbc84514b2?crop=entropy&cs=srgb&fm=jpg&q=85",
    className: "md:col-span-4",
  },
  {
    id: "brass",
    name: "Brass Pooja",
    items: "Traditional brass articles for the pooja room",
    img: "https://images.unsplash.com/photo-1755798320739-ebf99af9cfe6?crop=entropy&cs=srgb&fm=jpg&q=85",
    className: "md:col-span-4",
  },
];

const Card = ({ card, index }) => (
  <motion.article
    data-testid={`bento-card-${card.id}`}
    className={`group relative overflow-hidden rounded-2xl border border-white/5 bg-surface ${card.className} h-[300px] md:h-auto`}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay: index * 0.08 }}
  >
    <img
      src={card.img}
      alt={card.name}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/35 to-black/10" />
    <div className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[radial-gradient(ellipse_at_bottom_left,rgba(212,175,55,0.18),transparent_60%)]" />
    <div className="relative z-10 flex h-full flex-col justify-end p-7 md:p-8">
      <h3 className="font-display text-2xl font-semibold text-stone-50 md:text-3xl">
        {card.name}
      </h3>
      <p className="mt-2 max-w-md text-xs leading-relaxed text-stone-300 sm:text-sm">
        {card.items}
      </p>
      <span className="mt-4 font-mono text-[10px] uppercase tracking-[0.26em] text-brand-brass">
        In store
      </span>
    </div>
  </motion.article>
);

const Bento = () => (
  <section id="collection" className="px-5 py-24 md:px-8 md:py-32">
    <div className="mx-auto max-w-7xl">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-12 md:mb-16"
      >
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-brass">
          The Shelves
        </span>
        <h2 className="mt-4 font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Five aisles, <em className="italic text-brand-brass">one roof.</em>
        </h2>
        <p className="mt-5 max-w-lg text-sm leading-relaxed text-stone-400 sm:text-base">
          Every metal a South Indian kitchen asks for — picked, stacked and
          ready on the shelves of our Besant Nagar shop.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:grid-rows-2 md:auto-rows-[270px] md:gap-6">
        {CARDS.map((card, i) => (
          <Card key={card.id} card={card} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Bento;
